import { makeStyles } from "@material-ui/core";

export const useMessageItemStyles = makeStyles((theme) => ({  messageLeft: {
    marginRight: 150, // Aumentado ainda mais para acomodar o menu mais afastado
    marginTop: 1, // Reduzido para mensagens ficarem mais próximas
    marginBottom: 3, // Reduzido - espaçamento será controlado dinamicamente
    minWidth: 280, // AUMENTADO: largura mínima padronizada
    maxWidth: 700,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 300,
      marginRight: 100, // Ajustado para telas pequenas
      minWidth: 250, // Menor em mobile
    },
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s ease", // Transição suave para hover

    // 🎯 FloatingMessageActions - escondido por padrão
    "&:hover #messageActionsButton": {
      display: "none" // Removemos o botão antigo
    },

    // Efeito sutil de hover na mensagem
    "&:hover": {
      transform: "translateX(-2px)", // Move ligeiramente para destacar
      boxShadow: theme.mode === "light"
        ? "0 2px 8px rgba(0, 0, 0, 0.12)"
        : "0 2px 8px rgba(0, 0, 0, 0.3)",
    },

    whiteSpace: "pre-line",
    backgroundColor: theme.mode === "light" ? "#ffffff" : "#202c33",
    color: theme.mode === "light" ? "#303030" : "#ffffff",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow:
      theme.mode === "light" ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000",
  },
  // Wrapper neutro para mensagens de áudio (recebidas): mesmas margens/posicionamento, sem fundo/borda
  messageLeftBare: {
    marginRight: 150,
    marginTop: 1,
    marginBottom: 3,
    minWidth: 280,
    maxWidth: 700,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 300,
      marginRight: 100,
      minWidth: 250,
    },
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s ease",
    backgroundColor: "transparent",
    color: theme.mode === "light" ? "#303030" : "#ffffff",
    alignSelf: "flex-start",
    borderRadius: 0,
    padding: 0,
    boxShadow: "none",
  },
  messageRight: {
    marginLeft: 150, // Aumentado ainda mais para acomodar o menu mais afastado
    marginTop: 1, // Reduzido para mensagens ficarem mais próximas
    marginBottom: 3, // Reduzido - espaçamento será controlado dinamicamente
    minWidth: 280, // AUMENTADO: largura mínima padronizada
    maxWidth: 700,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 300,
      marginLeft: 100, // Ajustado para telas pequenas
      minWidth: 250, // Menor em mobile
    },
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s ease", // Transição suave para hover

    // 🎯 FloatingMessageActions - escondido por padrão
    "&:hover #messageActionsButton": {
      display: "none" // Removemos o botão antigo
    },

    // Efeito sutil de hover na mensagem
    "&:hover": {
      transform: "translateX(2px)", // Move ligeiramente para destacar (direção oposta)
      boxShadow: theme.mode === "light"
        ? "0 2px 8px rgba(0, 0, 0, 0.12)"
        : "0 2px 8px rgba(0, 0, 0, 0.3)",
    },

    whiteSpace: "pre-line",
    backgroundColor: theme.mode === "light" ? "#dcf8c6" : "#005c4b",
    color: theme.mode === "light" ? "#303030" : "#ffffff",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow:
      theme.mode === "light" ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000",
  },
  // Wrapper neutro para mensagens de áudio (enviadas): mesmas margens/posicionamento, sem fundo/borda
  messageRightBare: {
    marginLeft: 150,
    marginTop: 1,
    marginBottom: 3,
    minWidth: 280,
    maxWidth: 700,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 300,
      marginLeft: 100,
      minWidth: 250,
    },
    height: "auto",
    display: "block",
    position: "relative",
    transition: "all 0.2s ease",
    backgroundColor: "transparent",
    color: theme.mode === "light" ? "#303030" : "#ffffff",
    alignSelf: "flex-end",
    borderRadius: 0,
    padding: 0,
    boxShadow: "none",
  },
  messageRightPrivate: {
    marginLeft: 80, // Aumentado para dar espaço ao FloatingMessageActions (mesmo padrão das outras)
    marginTop: 20,
    marginBottom: 20,
    minWidth: 280, // PADRONIZADO: mesma largura mínima
    maxWidth: 600,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 60, // Reduzido em telas pequenas
      minWidth: 250, // Menor em mobile
    },
    height: "auto",
    display: "block",
    position: "relative",

    // 🎯 FloatingMessageActions - escondido por padrão
    "&:hover #messageActionsButton": {
      display: "none" // Removemos o botão antigo
    },

    whiteSpace: "pre-line",
    backgroundColor: "#F0E68C",
    color: "#303030",
    alignSelf: "flex-end", // Mantém alinhamento à direita
    borderRadius: 10,
    padding: 15,
    boxShadow:
      theme.mode === "light" ? "0 1px 1px #b3b3b3" : "0 1px 1px #000000",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 6px 6px 6px", // CORRIGIDO: removido padding direito excessivo (80px → 6px)
    overflow: "hidden", // ADICIONADO: garantir que o conteúdo não exceda o container
    maxWidth: "100%", // ADICIONADO: garantir largura máxima
    boxSizing: "border-box", // ADICIONADO: incluir padding no cálculo da largura
  },  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 6px 6px 6px", // CORRIGIDO: removido padding direito excessivo (80px → 6px)
    overflow: "hidden", // ADICIONADO: garantir que o conteúdo não exceda o container
    maxWidth: "100%", // ADICIONADO: garantir largura máxima
    boxSizing: "border-box", // ADICIONADO: incluir padding no cálculo da largura
  },

  messageMedia: {
    objectFit: "cover",
    width: 400,
    height: "auto",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 3,
    right: 5,
    color: theme.mode === "light" ? "#999" : "#ffffff",
  },

  forwardMessage: {
    fontSize: 12,
    fontStyle: "italic",
    position: "absolute",
    top: 0,
    left: 5,
    color: "#999",
    display: "flex",
    alignItems: "center",
  },
  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
    color: theme.mode === "light" ? theme.palette.light : theme.palette.dark,
  },

  // 🎵 Estilos específicos para mensagens de áudio integradas ao balão
  messageAudioLeft: {
    // Herda de messageLeft mas com padding otimizado para áudio
    padding: '8px 12px',
    minWidth: '260px',
    maxWidth: '320px',
    [theme.breakpoints.down("xs")]: {
      minWidth: '240px',
      maxWidth: '280px',
    },
  },

  messageAudioRight: {
    // Herda de messageRight mas com padding otimizado para áudio
    padding: '8px 12px',
    minWidth: '260px',
    maxWidth: '320px',
    [theme.breakpoints.down("xs")]: {
      minWidth: '240px',
      maxWidth: '280px',
    },
  },
}));
